import {IAngularEvent, IController, IModule} from "angular";
import {l} from "types/typescriptdefinisjoner_lederplan";
import _ from "lodash";
import {NyttMøteSkjemaModell} from "../../MøteTjeneste";

const css = require('./nyttMøteVelgMalsakerSkjema.scss');

export class NyttMøteVelgMalsakerKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular.component('wmNyttMøteVelgMalsakerSkjema', {
            bindings: {
                nyttMoeteModell: '<'
            },
            controller: NyttMøteVelgMalsakerKontroller.forInjisering(),
            template: require('./nyttMøteVelgMalsakerSkjema.html')
        });
    }

    static forInjisering() {
        return [
            NyttMøteVelgMalsakerKontroller
        ]
    }

    constructor() {
    }

    nyttMoeteModell: NyttMøteSkjemaModell; //settes via bindings

    ekspandertSakId: string = null;

    alleSakerValgt(){
        return this.nyttMoeteModell.spesifikasjon.valgteMalsaker.length == this.nyttMoeteModell.moetemal.saker.length;
    }

    ingenSakerValgt(){
        return this.nyttMoeteModell.spesifikasjon.valgteMalsaker.length == 0;
    }

    togleAlleSaker() {
        if (this.alleSakerValgt())
            this.nyttMoeteModell.spesifikasjon.valgteMalsaker = [];
        else
            this.nyttMoeteModell.spesifikasjon.valgteMalsaker = this.nyttMoeteModell.moetemal.saker
                .map(sak => sak.id);
    }

    erValgt(sak: l.MalsakModell): boolean {
        return this.nyttMoeteModell.spesifikasjon.valgteMalsaker.some(id => id === sak.id)
    }

    valgEndret(sak: l.MalsakModell) {
        this.erValgt(sak) ? _.remove(this.nyttMoeteModell.spesifikasjon.valgteMalsaker, id => id === sak.id) : this.nyttMoeteModell.spesifikasjon.valgteMalsaker.push(sak.id);
    }

    ekspander(sak: l.MalsakModell, $event:JQueryEventObject){
        //setter bredde på beskrivelses-feltet til eksisterende bredde på tittel-feltet slik at ikke visning av beskrivelse fører til økning i bredde på innhold
        const saksrad = angular.element($event.currentTarget).parents('.wm-nmvms-sak-rad');
        const bredde = saksrad.find('.wm-nmvms-sak-navn')[0].clientWidth
        saksrad.find('.wm-nmvms-sak-beskrivelse').css({'width': bredde});

        this.ekspandertSakId = sak.id;
    }

    kolaps(sak: l.MalsakModell){
        this.ekspandertSakId = null;
    }
}
